import jira from "../assets/Jira.svg";
import googleCalender from "../assets/googleCalender.png";
import salesForce from "../assets/Saleforce.png";
import keka from "../assets/keka.png";
import darwinbox from "../assets/darwin.png";
import dbf from "../assets/dbf.png";
import Telegram from "../assets/Telegram.png";
import whatsapp from "../assets/whatsapp.svg";
import odoo from "../assets/odoo.png";
import { GoogleOutlined } from "@ant-design/icons";
import "../Pages/integration/integration.scss";

const PAGE_ROUTES = {
  HOME: "/",
  CHAT: "/chat",
  INTEGRATION: "/integration",
  PROFILE: "/profile", // legacy path, redirects to SETTINGS
  SETTINGS: "/settings",
  PRIVACY_POLICY: "/privacy-policy",
  LOGIN: "/login",
  USER_ROLES: "/user-roles",
  CONTENT: "/content",
  CUSTOM: "/custom",
  USER_MANAGEMENT: "/user-management",
  ORGANIZATION: "/organization",
  ANALYTICS: "/analytics",
  // ANALYTICS_ACTIONS: "/analytics/actions", // not used
  BILLING: "/billing",
  BROADCAST_SEND_MESSAGE: "/broadcast/send-message",
  BROADCAST_SCHEDULED: "/broadcast/scheduled",
  BROADCAST_ANALYTICS: "/broadcast/analytics",
  BROADCAST_USER_GROUPS: "/broadcast/user-groups",
  BROADCAST_TEMPLATE: "/broadcast/template",
  BILLING_INVOICE: "/invoices",
  BILLING_INVOICE_APPROVAL: "/invoices-approval",
};
const API_ROUTES = {
  BASE_URL: process.env.REACT_APP_BACKEND_API_URL,
  AUTHENTICATION: {
    LOGIN_AUTH: "auth/google/login",
    LOGOUT_AUTH: "auth/google/logout",
    MFA_VERIFY_LOGIN: "auth/mfa/verify",
    MFA_SETUP: "auth/mfa/setup",
    MFA_VERIFY_SETUP: "auth/mfa/verify-setup",
    MFA_DISABLE: "auth/mfa/disable",
    MFA_REGENERATE_BACKUP_CODES: "auth/mfa/backup-codes/regenerate",
  },
  ADMIN: {
    ADMINS: "admins",
  },
  PROFILE: {
    GET_PROFILE_DETAILS: "/profile",
    UPDATE_PROFILE_DETAILS: "/profile/",
    CREATE_DOCUMENTS: "/admin/train/content/:type",
    UPLOAD_PROFILE_PICTURE: "/profile/picture",
  },
  CHAT: {
    GET_CHAT_DATA: `/chat`,
    FEEDBACK: "/feedback",
    UPLOAD_IMAGE_REGIGNATION: "/uploadMissing/upload",
    CHAT_SEARCH: "/chat/search",
  },
  ORGANIZATION: {
    ORG: "/organisation",
  },
  USERMANAGEMENT: {
    GET_All_USERS: "/admin/users",
    GET_USERS: "/admin/users",
    GET_ROLES: "/admin/role",
    GET_ALL_PERMISSIONS: "/admin/permission/all",
    GET_USER_PERMISSIONS: "/admin/permission",
    DELETE_USER: "/admin/user/:id",
    DELETE_MULTIPLE_USERS: "/admin/users/delete-multiple",
    SEND_REMINDER_EMAIL: "/admin/user/:id/reminder",
    ADD_NEW_USER: "/admin/user",
    UPLOAD_USER_BULK: "/admin/user/upload-users",
    UPDATE_USER: "/admin/user/:id",
  },
  INTEGRATION: {
    INTEGRATION: "/integration",
    UPDATE_INTEGRATION: "/integration/default",
    KEKA_INTEGRATION: "/integration/keka",
    DBF_INTEGRATION: "/integration/dbf",
    ODOO_INTEGRATION: "/integration/odoo/password-login",
    SELFBEST_INTEGRATION: "/integration/selfbest",
    TELEGRAM_INTEGRATION: "/integration/telegram",
    REMOVE_INTEGRATION: "/integration/",
    GET_ORG_INTEGRATION: "/app",
    ACTIVATE_INTEGRATION: "/app/activation",
    ACTIVATE_INTEGRATION_TELEGRAM: "/app/activation/telegram",
    ACTIVATE_INTEGRATION_WHATSAPP: "/admin/whatsapp",
    DARWINBOX: "/integration/darwinbox",
    WHATSAPP_INTEGRATION: "/integration/whatsapp",
    APP_MARKET_PLACE: "/superadmin/integrations",
    ORGANISATION_WISE_INTEGRATIONS:
      "/superadmin/organisation-wise/integrations",
    UPDATE_ORG_INTEGRATIONS: "/superadmin/integrations",
    CREATE_APP: "/superadmin/apps",
    UPDATE_APP: "/superadmin/apps",
    GET_YOUR_APPS: "/integration",
    GET_ORG_APPS: "/admin/apps",
    GET_ADMIN_APPS_MARKETPLACE: "/admin/apps-marketplace",
    ADMIN_APPS_MARKETPLACE_REQUEST: "/admin/apps-marketplace-request",
    UPDATE_ADMIN_INTEGRATION: "/admin/integrations",
    GET_CATEGORY: "superadmin/apps-categories",
    GET_APPS_INTEGRATION_REQUESTS: "/superadmin/apps-integration-requests",
    UPDATE_JIRA_PROJECT: "/integration/jira",
  },
  TRAINFROMECONTENT: {
    UPLOAD_PDF_DATA: "/admin/upload",
    DELETE_CONTENTS: "/admin/train/contents",
    UPLOAD_Text_DATA: "/admin/upload",
    UPLOAD_URL_DATA: "/admin/upload",
    GET_UPLOADED_DOCUMENT: "/admin/train/content",
    UPDATE_CONTENT_ROLES: "/admin/train/content/update-roles",
    CUSTOM_API: "/admin/train/custom-action",
    GET_CUSTOM_API: "/admin/train/custom-action",
    GET_SINGLE_DATA: "/admin/train/custom-action",
    GET_CUSTOM_ACTION_API: "/action",
    GET_ALL_NOTIFICATIONS: "/notification/notifications",
  },
  USER_ROLES: {
    GET_ROLES: "/admin/role",
    ADD_ROLE: "/admin/role/",
    EDIT_ROLE: "/admin/role",
    DELETE_ROLES: "/admin/role",
    GET_USERS: "/admin/role/users",
  },
  ANALYTICS: {
    GET_ANALYTICS_DATA: "/admin/analytics",
    GET_ANALYTICS_DATA_SUPER_ADMIN: "/superadmin/analytics",
    GET_BILLING_ANALYTICS_DATA: "/admin/unit-analytics/api",
    GET_BILLING_ANALYTICS_DATA_SUPER_ADMIN: "/superadmin/unit-analytics/api",
    GET_ACTION_WISE_ANALYTICS: "/feedback/action-wise-analytics",
    GET_TOTAL_ACTION_STATS: "/feedback/totalActionStats",
    // Both accept :organisationId in path: /feedback/action-wise-analytics/:organisationId, /feedback/totalActionStats/:organisationId
    GET_DASHBOARD_DATA: "analytics/dashboard",
    GET_ACTIVE_USERS: "analytics/active-users",
    GET_USERS_PER_ACTION: "analytics/users-per-app",
    GET_USER_WISE_ACTIONS: "analytics/user-wise-actions",
    GET_ACTION_WISE_PERFORMANCE: "analytics/action-wise-performance",
    GET_FEEDBACK_STATS: "analytics/feedback-stats",
    GET_NOT_SATISFIED_REQUESTS: "analytics/not-satisfied-requests",
    EXPORT_DASHBOARD_REPORT: "analytics/export-dashboard-report",
    EXPORT_ACTIONS_USERS_ANALYTICS: "analytics/export-actions-users-analytics",
  },
  BILLING_INVOICE: {
    GET_ALL_INVOICES: "/admin/invoices",
    GET_ALL_INVOICES_SUPER_ADMIN: "/superadmin/invoices",
    GET_INVOICES_APRROVAL: "/superadmin/approval-requests",
  },
  BROADCAST: {
    GROUPS: "/broadcast/groups",
    GROUP: "/broadcast/group",
    GROUP_DELETE: "/broadcast/group/bulk-delete",
    SEND_MESSAGE: "/broadcast",
    GET_BROADCAST: "/broadcast",
    TEMPLATES: "/broadcast/templates",
    SEND_TEMPLATE: "/broadcast/send-template",
    BULK_USER_GROUP: "/broadcast/bulk-user/group",
    EXPORT_SENT_USERS: "/broadcast/export-success-user",
    EXPORT_FAILED_USERS: "/broadcast/export-failed-user",
    UPLOAD_MEDIA: "/broadcast/whatsapp/media-upload",
    SCHEDULE_SEND: "/broadcast/schedule",
    GET_SCHEDULED: "/broadcast/schedule",
    DELETE_SCHEDULED: "/broadcast/schedule",
    UPDATE_SCHEDULED: "/broadcast/schedule",
  },
};

const API_URL =
  window.location.origin === "https://staging-app.simplifypath.com"
    ? "https://staging-api.simplifypath.com"
    : window.location.origin === "http://localhost:3000"
      ? "https://staging-api.simplifypath.com"
      : "https://api.simplifypath.com";

const DBF_API_URL =
  window.location.origin === "https://staging-app.simplifypath.com"
    ? "http://stg-dbf.tftus.com"
    : window.location.origin === "http://localhost:3000"
      ? "http://stg-dbf.tftus.com"
      : "https://dbf.tftus.com";

// const API_URL = process.env.REACT_APP_API_URL;

const ORIGIN_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const CONFIG = {
  TIMEOUT: 30000,
  UPLOAD_TIMEOUT: 60000,
};

const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Others" },
];

const experienceOptions = [
  "Freshers",
  "1 year",
  "2 years",
  "3 years",
  "4 years",
  "5 years",
  "6 years",
  "7 years",
  "8 years",
  "9 years",
  "10 years",
  "10+ years",
];

const logoMapping = {
  keka,
  dbf,
  google_calendar: googleCalender,
  jira,
  salesforce: salesForce,
  telegram: Telegram,
  gmail: <GoogleOutlined className="gmail-icon" />,
  darwinbox,
  whatsapp,
  selfbest: "https://simplifypath-prod.s3.amazonaws.com/apps/1768812865955-SelfBest.png",
  odoo,
  outlook: "https://simplifypath-prod.s3.amazonaws.com/apps/1781784958280-Outlook.png"
};

const Roles = {
  ADMIN: "admin",
  SUPER_ADMIN: "superadmin",
};

 const SCHEDULED_STATUS_COLORS = {
    SENT: "success",
    FAILED: "error",
    CANCELLED: "default",
    SCHEDULED: "processing",
  };

export {
  Roles,
  PAGE_ROUTES,
  API_ROUTES,
  CONFIG,
  API_URL,
  DBF_API_URL,
  genderOptions,
  experienceOptions,
  logoMapping,
  ORIGIN_CLIENT_ID,
  SCHEDULED_STATUS_COLORS,
};
